import React, { Component } from "react"
import { connect } from 'react-redux';
import Service from '../../../services';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { BasicLazyParams } from '../../../utile';
import Authentication from './../../session';
import LoadingComponent from '../../loadingComponent';
import { baseUrlAdmin } from '../../../store/apiConstants';
import withRouter from '../../lib/withRouter';
import './styles.scss'
import BranchToSectionDDPreFill from "../../BaseDropdownComponents/BranchToSectionDDPreFill";
import StudentPromotionModal from './studentPromotionModal.js';

class StudentPromotion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            globalSearch: '',
            students: [],
            lazyParams: BasicLazyParams,
            totalRecords: 0,
            dropdownsData: {},
            selectedStudents: new Map(), // Store selections for current page only
            selectAll: false,
            // Removed: allStudentsSelected
            showPromotionModal: false
        };
        this.service = new Service();
    }

    setDropdownValues = (dropdownsData) => {
        // Reset selections when dropdown changes
        this.setState({
            dropdownsData: dropdownsData,
            selectedStudents: new Map(),
            selectAll: false
            // Removed: allStudentsSelected: false
        }, () => {
            if (dropdownsData.branchId && dropdownsData.boardId && dropdownsData.classId && dropdownsData.sectionId) {
                this.filterUsersData()
            }
        })
    }

    filterUsersData = () => {
        this.setState({
            isLoading: true,
            students: []
        });

        let { lazyParams, globalSearch } = this.state;
        const payload = {
            branchId: this.state?.dropdownsData?.branchId ? [this.state.dropdownsData.branchId] : [],
            boardId: this.state?.dropdownsData?.boardId ? [this.state.dropdownsData.boardId] : [],
            classId: this.state?.dropdownsData?.classId ? [this.state.dropdownsData.classId] : [],
            sectionId: this.state?.dropdownsData?.sectionId,
        }

        const url = `${baseUrlAdmin}/promotions/students-with-fee-status?academicYear=${localStorage.getItem('userAcademicYear')}&limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}`;

        this.service.post(url, payload, true).then(res => {
            if (res && res.status && res.res.status) {
                this.setState({
                    isLoading: false,
                    students: res.res.Items,
                    totalRecords: res.res.totalRecords
                }, () => {
                    this.updateSelectAllState();
                });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        })
    }

    onPage = (event) => {
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.filterUsersData);
    }

    onSort = (event) => {
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.filterUsersData);
    }

    onFilter = (event) => {
        event['first'] = 0;
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    filters: event.filters
                }
            };
        }, this.filterUsersData);
    }

    // Handle individual row selection
    onRowSelect = (rowData, checked) => {
        const newSelectedStudents = new Map(this.state.selectedStudents);

        if (checked) {
            newSelectedStudents.set(rowData.user_id, rowData);
        } else {
            newSelectedStudents.delete(rowData.user_id);
        }

        this.setState({
            selectedStudents: newSelectedStudents
        }, () => {
            this.updateSelectAllState();
        });
    }

    // Handle select all for current page only
    onSelectAllCurrentPage = (checked) => {
        const newSelectedStudents = new Map(this.state.selectedStudents);

        if (checked) {
            // Add all current page students
            this.state.students.forEach(student => {
                newSelectedStudents.set(student.user_id, student);
            });
        } else {
            // Remove all current page students
            this.state.students.forEach(student => {
                newSelectedStudents.delete(student.user_id);
            });
        }

        this.setState({
            selectedStudents: newSelectedStudents
        }, () => {
            this.updateSelectAllState();
        });
    }

    updateSelectAllState = () => {
        const currentPageSelected = this.state.students?.every(student =>
            this.state.selectedStudents.has(student.user_id)
        );

        this.setState({
            selectAll: currentPageSelected && this.state.students?.length > 0
        });
    }

    // Template for selection checkbox
    selectionTemplate = (rowData) => {
        const isSelected = this.state.selectedStudents.has(rowData.user_id);

        return (
            <Checkbox
                checked={isSelected}
                onChange={(e) => this.onRowSelect(rowData, e.checked)}
            />
        );
    }
 
    selectAllTemplate = () => {
        return (
            <Checkbox
                checked={this.state.selectAll}
                onChange={(e) => this.onSelectAllCurrentPage(e.checked)}
            />
        );
    }

    // Handle promote students
    onPromoteStudents = () => {
        const selectedStudentIds = Array.from(this.state.selectedStudents.keys());

        if (selectedStudentIds?.length === 0) {
            this.toast.show({
                severity: 'warning',
                summary: 'Warning',
                detail: 'Please select at least one student to promote',
                life: 3000
            });
            return;
        }

        // TODO: Implement promotion logic
        console.log('Promoting students:', selectedStudentIds);
        this.toast.show({
            severity: 'success',
            summary: 'Success',
            detail: `${selectedStudentIds?.length} students selected for promotion`,
            life: 3000
        });
    }

    // Template for Fee Dues column
    feeDuesTemplate = (rowData) => {
        const feeStatus = rowData?.feeStatus;

        if (!feeStatus || feeStatus.totalDues === undefined) {
            return <span>N/A</span>;
        }

        const amount = feeStatus.totalDues || 0;

        return (
            <div style={{
                color: amount > 0 ? 'red' : 'green',
                fontWeight: 'bold'
            }}>
                ₹{amount.toLocaleString()}
            </div>
        );
    }

    // Add method to get current year data
    getCurrentYearData = () => {
        const { dropdownsData } = this.state;
        const userAcademicYear = localStorage.getItem('userAcademicYear');

        return {
            branchId: dropdownsData.branchId,
            branchName: dropdownsData.selectedbranchName,
            boardId: dropdownsData.boardId,
            boardName: dropdownsData.selectedBoardName,
            classId: dropdownsData.classId,
            className: dropdownsData.selectedClassName,
            sectionId: dropdownsData.sectionId,
            sectionName: dropdownsData.selectedsectionName,
            academicYear: userAcademicYear
        };
    };

    render() {
        const selectedCount = this.state.selectedStudents.size;

        return (
            <div>
                <BranchToSectionDDPreFill setValues={this.setDropdownValues} />

                <div className="flex justify-content-end mx-4 my-3">
                    <Button
                        label={`Promote Students`}
                            // ${selectedCount > 0 ? ` (${selectedCount})` : ''}
                            // `}
                        className="p-button-primary"
                        style={{ backgroundColor: '#076EFF', margin:'5px', padding:'15px', borderRadius:'8px', fontSize:'20px' }}
                        disabled={selectedCount === 0}
                        onClick={() => this.setState({ showPromotionModal: true })}
                        icon="pi pi-arrow-up"
                    />

                    {this.state.showPromotionModal && (
                        <StudentPromotionModal
                            onClose={() => this.setState({ showPromotionModal: false })}
                            selectedStudentIds={Array.from(this.state.selectedStudents.keys())}
                            selectedStudentsData={this.state.selectedStudents}
                            currentBranchId={this.state.dropdownsData.branchId}
                            currentYearData={this.getCurrentYearData()} // Pass current year data
                        />
                    )}
                </div>

                <div className="card datatable-crud-demo mt-5 mx-4">
                    <DataTable ref={(el) => this.dt = el}
                        value={this.state.students}
                        paginator
                        className="dataTableValuesText"
                        responsiveLayout="scroll"
                        showGridlines
                        columnResizeMode="expand"
                        resizableColumns
                        rows={this.state.lazyParams.rows}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        onPage={this.onPage}
                        onSort={this.onSort}
                        onFilter={this.onFilter}
                        lazy
                        first={this.state.lazyParams.first}
                        totalRecords={this.state.totalRecords}
                    >
                        <Column
                            header={this.selectAllTemplate}
                            body={this.selectionTemplate}
                            style={{ width: "4rem", height: "6rem" }}
                            alignHeader={"center"}
                            headerClassName="text-color-secondary"
                            bodyClassName='text-center'
                        />
                        <Column
                            field="user_info.given_name"
                            header="Student Name"
                            sortable
                            style={{ width: "15rem", height: "6rem" }}
                            alignHeader={"center"}
                            headerClassName="text-color-secondary"
                            bodyClassName='text-center'
                            body={(rowData) => {
                                return <>{`${rowData?.user_info?.firstName || ''} ${rowData?.user_info?.lastName || ''}`}</>
                            }}
                        />
                        <Column
                            field="user_info.enrollmentId"
                            header="Enrollment No"
                            sortable
                            style={{ width: "15rem", height: "6rem" }}
                            alignHeader={"center"}
                            headerClassName="text-color-secondary"
                            bodyClassName='text-center'
                        />
                        <Column
                            field="user_info.branchName"
                            header="Branch Name"
                            sortable
                            style={{ width: "15rem", height: "6rem" }}
                            alignHeader={"center"}
                            headerClassName="text-color-secondary"
                            bodyClassName='text-center'
                        />
                        <Column
                            field="user_info.custom:board"
                            header="Board Name"
                            sortable
                            style={{ width: "15rem", height: "6rem" }}
                            alignHeader={"center"}
                            headerClassName="text-color-secondary"
                            bodyClassName='text-center'
                        />
                        <Column
                            field="user_info.custom:grade"
                            header="Grade - Section"
                            sortable
                            style={{ width: "15rem", height: "6rem" }}
                            alignHeader={"center"}
                            headerClassName="text-color-secondary"
                            bodyClassName='text-center'
                            body={(rowData) => {
                                return (
                                    <div>
                                        {rowData?.user_info?.["custom:grade"]}-{rowData?.user_info?.sectionName}
                                    </div>
                                )
                            }}
                        />
                        <Column
                            header="Fee Dues"
                            sortable
                            style={{ width: "12rem", height: "6rem" }}
                            alignHeader={"center"}
                            headerClassName="text-color-secondary"
                            bodyClassName='text-center'
                            body={this.feeDuesTemplate}
                        />
                    </DataTable>
                    <Toast ref={(el) => this.toast = el} position="bottom-right" />
                    {this.state.isLoading && <LoadingComponent />}
                </div>
            </div>
        );
    }
}

export default connect(null, {})(Authentication(withRouter(StudentPromotion)));